import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchNotificationSettingsMetadata } from "model/NotificationSettingsModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const NotificationSettingsContext = createContext();

export const NotificationSettingsProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [notificationSettingsContextData, setNotificationSettingsContextData] =
    useState();

  const fetchNotificationSettingsContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema(
        "metadata:notificationSettings",
        () => fetchNotificationSettingsMetadata({})
      );
      if (response?.success !== false) {
        setNotificationSettingsContextData(response?.data ?? response);
      }
    } catch (err) {
      toast.error(err?.message || "Unable to load notification settings metadata");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <NotificationSettingsContext.Provider
      value={{
        fetchNotificationSettingsContextData,
        notificationSettingsContextData,
        loading,
        error,
      }}
    >
      {children}
    </NotificationSettingsContext.Provider>
  );
};

export const useNotificationSettingsContext = () =>
  useContext(NotificationSettingsContext);
